import { create } from 'zustand';

// gymFuel — the can the fitness instructor handed you, and the minute it gives you.
//
// Khari, 2026-10-31: "Like the coffee shop, a drink is available. It is
// 'GangstaFuel' Energy Drink. When the user drinks it, their movement is sped up
// for 1 minute and the screen is brighter."
//
// The instructor's hand_fuel (API GymService, on the counter seam) comes back as
// `out.fuel = { drink }`; worldJob applyRoleOut puts a CAN here, for a room with
// a fuel bar (rooms.js `fuel`). The can stands on the bar (GymFloor) until you
// drink it — tap it, or "Drink it" in the dock — and then it is gone and the
// BOOST runs: a minute of faster walking, everywhere (indoors: PlanetScene's
// InteriorWalk; outside: walkBody's top speed), and a brighter screen
// (EnergyBoost). Nobody else sees any of it: it is your drink.
//
// A STORE OF ITS OWN, like counterItems: the job's applier, the dock, the room
// and two movement loops read it, and the timers live here so a can goes after
// its while even if nothing in the room is drawing it.

export const BOOST_MS = 60000;       // "sped up for 1 minute"
export const BOOST_SPEED = 1.6;      // how much faster you move meanwhile
const CAN_MS = 3 * 60000;            // an untouched can is cleared away after this

export const useGymFuel = create(() => ({ can: null, boostUntil: 0 }));

let canTimer = null;

/** The instructor set a can on `zone`'s bar. Replaces one already standing there. */
export function placeFuel({ zone, drink = 'GangstaFuel', roleKey = null }) {
  if (!zone) return;
  clearTimeout(canTimer);
  const id = Date.now();
  useGymFuel.setState({ can: { id, zone, drink: String(drink || 'GangstaFuel').slice(0, 40), roleKey, at: id } });
  canTimer = setTimeout(() => clearFuel(zone, id), CAN_MS);
}

/** Take the can away — only `zone`'s, and only can `id` when given. */
export function clearFuel(zone = null, id = null) {
  const c = useGymFuel.getState().can;
  if (!c || (zone && c.zone !== zone) || (id && c.id !== id)) return;
  clearTimeout(canTimer);
  useGymFuel.setState({ can: null });
}

/** Drink it: the can goes, the minute starts (a second can restarts the minute, it does not stack). */
export function drinkFuel() {
  const c = useGymFuel.getState().can;
  if (!c) return false;
  clearTimeout(canTimer);
  useGymFuel.setState({ can: null, boostUntil: Date.now() + BOOST_MS });
  console.info(`[gym] drank a ${c.drink}: ${BOOST_MS / 1000}s of speed and light`);
  return true;
}

/** The movement multiplier right now (read every frame by the walk code; cheap). */
export function boostFactor() {
  return Date.now() < useGymFuel.getState().boostUntil ? BOOST_SPEED : 1;
}
